export default "__VITE_ASSET__aea99660__"